import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import SideBar from './MENU/SideBar'
import LoadingModal from '../../MOLECULES/LOADING/LoadingModal'

const LayoutDojangManagement = () => {
  return (
    <>
      <div className='bg-body'>
        <div className='main-wrap'>
          <SideBar />
          <Suspense fallback={<LoadingModal />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </>
  )
}

export default LayoutDojangManagement
